'use client';

import { c as _c } from "react/compiler-runtime";
import type { MapMode } from '~/components/map';
import { InlineMap } from '../itinerary/InlineMap';
import { TRANSPORT_ITINERARY_SECTION_ID } from './transportSections';
type TransportLegsMapSheetProps = {
  onClose: () => void;
};
export const TransportLegsMapSheet = t0 => {
  const $ = _c(2);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    const handleModeChange = next => {
      if (next === "compact") {
        onClose();
      }
    };
    t1 = <InlineMap mode="expanded" onModeChange={handleModeChange} sectionId={TRANSPORT_ITINERARY_SECTION_ID} variant="transport" />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};